module.exports = __webpack_public_path__ + "img/allstar_cn.bae4da1.jpg";